module.exports = __webpack_public_path__ + "static/media/potter_signature.4c23ec95.png";